import { defineStore } from 'pinia';
import type { RouteLocationNormalized } from 'vue-router';

export interface RouteIndexItem {
  value: RouteLocationNormalized;
  indexed: number;
}

export const useRouteStore = defineStore('routes', {
  state: () => ({
    pages: [] as RouteLocationNormalized[]
  }),
  getters: {
    getIndex(): RouteIndexItem[] {
      const newrray = this.pages.map((value, index) => ({
        value,
        indexed: index
      }))

      return newrray;
    },
    getHistory(): RouteIndexItem[] {
      const h = [...this.getIndex].sort((a, b) => b.indexed - a.indexed);
      const t = h.slice(0, 20);
      return t;
    }
  },
  actions: {
    goto(value: RouteLocationNormalized) {
      this.pages.push(value);
    },
    find(value: string) {

      const results = this.pages.filter(f => (JSON.stringify(f).toLowerCase() === value.toLowerCase()));

      return results;

   },
  }
})

